<template>
  <div id="app">
    <HansaTemporaryView />
  </div>
</template>

<script>
import HansaTemporaryView from "./components/HansaTemporaryView.vue";

export default {
  name: "app",
  components: {
    HansaTemporaryView
  }
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
@font-face {
  font-family: "FreeSet";
  src: url("./fonts/FreeSet.woff2") format("woff2"),
    url("./fonts/FreeSet.woff") format("woff");
  font-weight: normal;
  font-style: normal;
}
</style>
